import { IFetchData, ILastFetchData, IPriceDataSummary } from "../../interfaces/markets"
import { getFetchStatus } from "../../utils/validation"
import { marketpricesApi } from "./marketpricesApi"

export const dashboardApi = marketpricesApi.injectEndpoints({
  endpoints: builder => ({
    getPriceDataSummary: builder.query<IPriceDataSummary, { startMonth: number; endMonth: number }>({
      query: params => ({
        url: "Dashboard/getpricedatauploadssummary",
        method: "GET",
        params,
      }),
      providesTags: ["PriceDataSummary"],
    }),
    getLastFetchData: builder.query<ILastFetchData[], { status?: number; startDate?: string } | void>({
      query: params => ({
        url: "Dashboard/getLastFetchOperations",
        method: "GET",
        params,
      }),
      transformResponse: (response: ILastFetchData[]) =>
        response.map(item => ({
          ...item,
          status: getFetchStatus(item.fetchingResponseCodeId),
        })),
      providesTags: ["LastFetchData"],
    }),
    getFetchOperations: builder.query<
      IFetchData[],
      { status?: number; startDate?: string; mappingSchemaId?: number } | void
    >({
      query: params => ({
        url: "Dashboard/getFetchOperations",
        method: "GET",
        params,
      }),
      providesTags: ["FetchOperations"],
    }),
  }),
})

export const { useGetPriceDataSummaryQuery, useGetLastFetchDataQuery, useGetFetchOperationsQuery } = dashboardApi
